export enum OrderDirection {
  asc = 'asc',
  desc = 'desc',
}
